<template>
  <div>
    <div class="edit-editor">
      <div class="edit-editor-title">
        <div class="edit-back" @click="profileBack">
          <i class="iconfont iconchevron-left"></i>返回
        </div>
        <div class="edit-module-name text-overflow default">{{editModuleData.title || '基本信息'}}</div>
        <button class="edit-module-save" @click="debounceSave" :disabled="!infoNotEmpty(formData, currentInfo.type)">保存</button>
      </div>
      <!-- 基本信息 -->
      <div class="edit-editor-content">
        <!-- 固定 input 渲染 -->
        <el-form ref="editModuleBasicInfo" :model="formData" :rules="rules" :show-message="isShowRulesMsg" :class="{'check-unnecessary': !saveRules}">

          <!-- 姓名 -->
          <div class="position-r">
            <div class="edit-module-item-name">姓名</div>
            <el-form-item prop="username" class="position-r">
              <el-input v-model="formData.username" placeholder="如：陈媛媛 Abbey" clearable
                        @input="val => change('formData', 'username', val)"/>
            </el-form-item>
            <suggest-card v-if="suggestInfo.suggest && suggestInfo.field === 'username'"
                          @handleClose="closeCard"></suggest-card>
          </div>

          <!-- 电话 and 邮箱 -->
          <div class="edit-editor-menu margin-top-24 position-r">
            <div class="edit-editor-item">
              <div class="edit-module-item-name">电话</div>
              <el-form-item prop="phone" class="position-r">
                <el-input
                    v-model="formData.phone"
                    placeholder="如：138-8888-8888"
					clearable
                    @input="val => change('formData', 'phone', val)"/>
              </el-form-item>
            </div>
            <div class="edit-editor-item">
              <div class="edit-module-item-name">邮箱</div>
              <el-form-item prop="email" :class="{'no-style': noStyle}">
                <el-input
                    v-model="formData.email"
                    placeholder="如：abbey@wondercv.com"
					clearable
                    @input="val => change('formData', 'email', val)"/>
              </el-form-item>
            </div>
            <suggest-card v-if="suggestInfo.suggest && (suggestInfo.field === 'email' || suggestInfo.field === 'phone')"
                          @handleClose="closeCard"></suggest-card>
          </div>

          <!-- 现居城市 -->
          <div class="edit-module-item-name margin-top-24">现居城市</div>
          <el-form-item class="margin-top-38">
            <el-input
                v-model="formData.address"
                placeholder="如：北京"
                clearable
                @input="val => change('formData', 'address', val)"/>
          </el-form-item>

        </el-form>

        <!-- 手动添加 input 渲染 -->
        <div class="edit-editor-menu">
          <template v-for="(item, index) in infoModule" >
          <div class="edit-editor-item margin-top-24" :key="index" v-if="item.key !== 'exp_job' && item.key !== 'current_job' && item.key !== 'expected_salary'">
            <div class="edit-module-item-name">{{item.title}}</div>
            <!-- 性别 -->
            <div v-if="item.key === 'gender'">
              <el-select v-if="cvLang === 'cn'" clearable v-model="formData[item.key]"
                         :placeholder="item.placeholder || '请选择'" @change="val => change('', item.key, val)">
                <el-option v-for="option in ['男', '女']" :key="option" :label="option" :value="option"/>
              </el-select>
              <el-input v-else placeholder="请填写" v-model="formData[item.key]" clearable
                        @input="val => change('', item.key, val)"/>
            </div>
            <!-- // 政治面貌 -->
            <div v-else-if="item.key === 'political_status'">
              <el-select v-if="cvLang === 'cn'" clearable v-model="formData[item.key]"
                         :placeholder="item.placeholder || '请选择'" @change="val => change('', item.key, val)">
                <el-option v-for="option in ['中共党员', '中共预备党员', '共青团员', '群众']" :key="option" :label="option"
                           :value="option"/>
              </el-select>
              <el-input v-else v-model="formData[item.key]" placeholder="请填写" clearable
                        @input="val => change('', item.key, val)"/>
            </div>
            <!-- 年龄生日 -->
            <div v-else-if="item.key === 'birthday'">
              <div style="position: relative;">
                <div class="edit-item-now ageAndBirth" style="width: calc(100% - 60px);">{{ageBirthday || '请选择'}}</div>
                <el-date-picker value-format="yyyy-MM" v-model="formData[item.key]" type="month"
                                :picker-options="pickerOptions" :placeholder="item.placeholder || '请选择'"
								:default-value="(new Date().getFullYear() - 22 + '-06') || ''"
                                @change="val => change('', item.key, val)"/>
              </div>
              <!-- <el-input
                v-else
                v-model="item.value"
                placeholder="请填写"
                @input="val => change('', item.key, val)"/> -->
              <!-- @input="chosenChange" -->
              <cv-radio style="justify-content: flex-end;margin-top: 4px;margin-left: 14px;margin-bottom: -15px;"
                        line="one" :value='chosen' v-model="chosen"
                        :list="[{ value: 'age', content: '年龄' }, { value: 'birthday', content: '生日' }]"
                        @input="chosenChange(chosen)"
              />
            </div>
            <!-- 除 性别、政治面貌、年龄生日 外其他模块 -->
            <el-input v-else clearable :placeholder="item.placeholder || '请填写'" v-model="formData[item.key]" @input="val => change('', item.key, val)"/>
          </div>
          </template>
        </div>

        <!-- 固定 求职意向 input 渲染 -->
        <div class="module-title">求职意向</div>
        <!-- 当前状态 and 意向城市 -->
        <div class="edit-editor-menu margin-top-24 position-r">
          <div class="edit-editor-item">
            <div class="edit-module-item-name">当前状态</div>
            <el-input ref="currentJobRef" v-model="formData.current_job" placeholder="如：在职，看看机会" maxlength="50" clearable @focus="showCurrentJobBox(true)" @blur="hiddenCurrentJobBox()"/>
          </div>
          <div class="edit-editor-item">
            <div class="edit-module-item-name">意向城市</div>
            <autoplay-city  :value="formData.exp_city" @select="selectCityValue"/>
          </div>
        </div>
        <!-- 当前状态 选择项 -->
        <div class="current-job-box" v-if="currentJobBoxVisible">
          <div class="current-job-item" :class="{'active': item === formData.current_job }" v-for="(item, index) in currentJobMap" :key="`currentJobItem&${index}`" @click="toggleCurrentJob(item)">
            {{ item }}
          </div>
        </div>
        <!-- 期望职位 and 期望薪资 -->
        <div class="edit-editor-menu margin-top-24 position-r">
          <div class="edit-editor-item">
            <div class="edit-module-item-name">期望职位</div>
            <autoplay-position :value="formData.exp_job" @select="selectPisitionValue"/>
          </div>
          <div class="edit-editor-item">
            <div class="edit-module-item-name">期望薪资</div>

            <div class="edit-editor-salary">

              <label class="salary-item">
                <el-select :clearable="expect_min_salary === 100" v-model="expect_min_salary" placeholder="最低薪资" @change="min => (minChange(min), selectSalaryFun())">
                  <el-option
                    v-for="item in 100"
                    :key="item"
                    :label="item === 100 ? '100k以上' : item + 'k'"
                    :value="item">
                  </el-option>
                </el-select>
              </label>

              <span class="salary-item-text" v-if="expect_min_salary < 100">至</span>

              <label class="salary-item" v-if="expect_min_salary < 100">
                <el-select clearable v-model="expect_max_salary" placeholder="最高薪资" @change="max => (maxChange(max), selectSalaryFun())">
                  <el-option
                    v-for="item in 100"
                    v-if="item > expect_min_salary && item <= expect_min_salary * 2"
                    :key="item"
                    :label="item + 'k'"
                    :value="item">
                  </el-option>
                </el-select>
              </label>

            </div>

            <!-- <el-select v-model="formData.expected_salary" placeholder="请选择期望薪资" clearable @change="selectSalaryValue">
              <el-option
                v-for="item in 100"
                :key="item"
                :label="item === 100 ? '100k以上' : `${item}k-${item+1}k`"
                :value="item">
              </el-option>
            </el-select> -->

          </div>
        </div>

        <div class="name margin-top-38 font-size-14" v-if="infoMenu[0].length">社交信息</div>
        <div class="add-module margin-top-24" v-if="infoMenu[0].length">
          <div class="add-module-menu" v-for="(item, index) in infoMenu[0]" :key="index"
               @click="addModule(item, index, 0)">
            <b>+</b><span>{{item.title}}</span>
          </div>
        </div>

        <div class="name margin-top-24 font-size-14" v-if="infoMenu[1].length">其他信息</div>
        <div class="add-module margin-top-24" v-if="infoMenu[1].length">
          <div class="add-module-menu" v-for="(item, index) in infoMenu[1]" :key="index"
               @click="addModule(item, index, 1)">
            <b>+</b><span>{{item.title}}</span>
          </div>
        </div>

      </div>
<!--      <cv-auxiliary></cv-auxiliary>-->
<!--      <div class="edit-editor-btn">-->
<!--        <div></div>-->
<!--        <div class="btn-box">-->
<!--          <button class="close-btn" @click="back">取消</button>-->
<!--          <button class="complete-btn" :class="{'baseInfo-btn': !infoNotEmpty(formData, 'basicInfo')}"-->
<!--                  @click="debounceSave">保存-->
<!--          </button>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	import api from '@/api'
	import richText from '@/components/base/richText'
	import cvRadio from '@/components/base/cvRadio'
  import cvAuxiliary from './cv-auxiliary'
	import rules from '@/assets/json/rules'
	import moment from 'moment'
	import { cvMixin } from '../../../../../assets/js/mixins'
	import suggestCard from '../../../../../components/editor/suggest-card'
	import { setEditNumLocalStorage, debounce } from '@/assets/js/util'
  import autoplayCity from '@/views/editorResume/cvsEditor/components/select/autoplayCity'
  import autoplayPosition from '@/views/editorResume/cvsEditor/components/select/autoplayPosition'

	const placeholder = {
		'homepage': '个人网站',
		'wechat': '微信',
		'linked_in': 'LinkedIn',
		'height': '身高',
		'weight': '体重',
		'ethnic': '民族',
		'hometown': '籍贯',
		'political_status': '政治面貌',
		'marriage': '婚姻状况',
		'gender': '性别',
		'birthday': '年龄或生日',
		'exp_job': '求职意向',
		'current_job': '当前工作状态',
		'expected_salary': '期望薪资'
	}

	const infoMenu = [
		[
			{
				key: 'homepage',
				title: placeholder.homepage,
				placeholder: '如：github.com/wondercv.com'
			},
			{
				key: 'wechat',
				title: placeholder.wechat,
				placeholder: '请填写'
			},
			{
				key: 'linked_in',
				title: placeholder.linked_in,
				placeholder: '请填写领英账号'
			}
		],
		[
			{
				key: 'birthday',
				title: placeholder.birthday,
				placeholder: ''
			},
			{
				key: 'gender',
				title: placeholder.gender,
				placeholder: ''
			},
			{
				key: 'height',
				title: placeholder.height,
				placeholder: '如：160 cm'
			},
			{
				key: 'weight',
				title: placeholder.weight,
				placeholder: '如：60 kg'
			},
			{
				key: 'ethnic',
				title: placeholder.ethnic,
				placeholder: '如：汉族'
			},
			{
				key: 'hometown',
				title: placeholder.hometown,
				placeholder: '请填写'
			},
			{
				key: 'political_status',
				title: placeholder.political_status,
				placeholder: '请选择'
			},
			{
				key: 'marriage',
				title: placeholder.marriage,
				placeholder: '请填写'
			},
			// {
			// 	key: 'exp_job',
			// 	title: placeholder.exp_job,
			// 	placeholder: '请填写意向岗位'
			// },
			// {
			// 	key: 'current_job',
			// 	title: placeholder.current_job,
			// 	placeholder: ''
			// },
			// {
			// 	key: 'expected_salary',
			// 	title: placeholder.expected_salary,
			// 	placeholder: '如：10k'
			// }
		]
	]

	export default {
		name: 'editModelBasicInfo',
		mixins: [ cvMixin ],
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		data () {
			// 验证规则
			return {
				debounceSave: null,
				formData: {
					username: '',
					phone: '',
					email: '',
					address: '',
					birthday_format: 'birthday',
					birthday: '',

          current_job: '',
          expected_salary: '',
          exp_job: '',
          exp_city: '',
          city_id: '',
          profession_id: '',

					format_pref: {
						age_birthday: {
							chosen: 'age'
						}
					},
				},
        intentionData: {
          current_job: null, // 当前状态
          exp_city: null, // 意向城市
          exp_job: null, // 期望职位
          expected_salary: null // 期望薪资
        },
        currentJobMap: [ '在职', '离职', '应届生', '在职，正在找工作', '待业', '在读', '应届毕业生', '离职，随时到岗', '在校生', '随时到岗', '正在找工作', '求职中', '实习中', '在职，考虑机会', '在职，月内到岗' ],
        currentJobBoxVisible: false, // 控制 当前状态选择项 显示和隐藏
        currentJobBoxTimer: null,

				chosen: 'age',
				// oldFormData: {},
				// oldInfoModule: {},
				// 日期选择的配置
				pickerOptions: {
					disabledDate (time) {
						return time.getTime() > Date.now()
					}
				},
				infoMenu: JSON.parse(JSON.stringify(infoMenu)),
				// 手动添加的模块, 数据来源 info menu
				infoModule: [],
				// 验证规则
				noStyle: true,
				// 是否展示验证信息
				isShowRulesMsg: true,
				saveRules: false,
				// rules: {
				// 	username: [
				// 		{ required: true, message: '请输入姓名', trigger: 'change' }
				// 	],
				// 	phone: [
				// 		// { validator: phone, trigger: [ 'blur', 'change' ] }
				// 		{ required: true, message: '请输入手机号', trigger: 'change' }
				// 	],
				// 	email: [
				// 		{ required: true, message: '请输入邮箱地址', trigger: 'blur' },
				// 		{ type: 'email', message: '请输入正确的邮箱地址', trigger: [ 'blur', 'change' ] }
				// 	]
				// }
        expect_min_salary: '',
        expect_max_salary: ''
			}
		},
		computed: {
			...mapState('cvsEditor', [ 'CONST_KIND', 'cvToken', 'cvDetail', 'editModuleData' ]),
			...mapState('cvs', [ 'cv', 'editorCvToken', 'highlightShow' ]),
			...mapState('editor', [ 'profile', 'cvDetail', 'currentInfo', 'backUpInfo', 'suggestInfo', 'checkCloseEditModule', 'openSidebarModule', 'isFirstCvInfo', 'quitResumeEditor' ]),
			isActive () {
				let profile = this.profile
				// let phoneReg = /^1[3-9]\d{9}$/gim
				let emailReg = /^[a-zA-Z0-9_\-\.]+@[a-zA-Z0-9_\-\.]+(\.[a-zA-Z0-9_-]+)+$/
				let isActive = false
				isActive = profile.username
					&& profile.phone && profile.phone.length
					&& emailReg.test(profile.email)
				return isActive
			},
			// 简历语言
			cvLang () {
				let { basic_info: { lang } } = this.cvDetail
				return lang || 'cn'
			},
			// 当前编辑模块的数据
			// formData () {
			// 	// 表单数据-必传数据
			// 	let keys = this.profile ? Object.keys(this.profile) : [];
			// 	return keys.length ? this.profile : {
			// 		username: '',
			// 		phone: '',
			// 		email: '',
			// 		address: '',
			// 		birthday_format: 'birthday'
			// 	}
			// },
			// 年龄或者生日
			ageBirthday () {
				let { basic_info: { lang } } = this.cvDetail
				let { format_pref, birthday } = this.formData
				//判断是否选择的生日
				if (this.chosen === 'birthday') {
					return birthday
				} else {
					if (birthday) {
						return `${ moment().diff(birthday, 'years') }${ lang === 'cn' ? '岁' : '' }`
					}
					return ''
				}

				// return this.formData.format_pref.age_birthday.chosen === 'birthday' ? this.formData.birthday : `${ moment().diff(this.formData.birthday, 'years') }${ lang === 'cn' ? '岁' : '' }`
			},
			rules () {
				const nameValidator = (rule, value, callback) => {
					// let reg = new regExp('[`~!@#$^&*()=|{}\':;\',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“\'。，、？\d]')
          let regEn = /[`~!@#$%^&*_+<>?～……:"{},.\/;'[\]]/im
          let regCn = /[·！#￥¥——：；“”‘、，|《。》？、【】[\]]/im
          let regNum = /\d/im
					if (value.length > 60) {
						return callback(new Error('姓名栏内容过长，建议删减哦'))
					} else if (regEn.test(value) || regCn.test(value) || regNum.test(value)) {
						return callback(new Error('含数字或特殊符号，请检查'))
					} else {
						return callback()
					}
				}
				const phoneValidator = (rule, value, callback) => {
          if (!/^1[3-9]\d{9}$/.test(value.replace(/-/g, ''))) {
						return callback(new Error('手机号很重要，不要填错了哦'))
					} else {
						return callback()
					}
				}
				return this.saveRules ? {
						username: [
							{ required: true, message: '请输入姓名', trigger: 'change' }
						],
						phone: [
							// { validator: phone, trigger: [ 'blur', 'change' ] }
							{ required: true, message: '请输入手机号', trigger: 'change' }
						],
						email: [
							{ required: true, message: '请输入邮箱地址', trigger: 'blur' },
							{ type: 'email', message: '请输入正确的邮箱地址', trigger: [ 'blur', 'change' ] }
						]
					} :
					{
						username: [
							{ validator: nameValidator, trigger: [ 'blur' ] }
						],
						phone: [
							{ validator: phoneValidator, trigger: [ 'blur' ] }
						]
					}
			},
		},
		created () {
			this.debounceSave = debounce(this.save, 300)
			let keys = this.profile ? Object.keys(this.profile) : []
			if (!keys.length) {
				this.setProfileData(this.formData)
			}
			this.formData = this.profile
			if(!this.formData.format_pref){
				this.formData.format_pref = {
					age_birthday: {
						chosen: 'age'
					}
				}
			}else if(!this.formData.format_pref.age_birthday){
				this.formData.format_pref.age_birthday = {
					chosen: 'age'
				}
			}
			this.chosen = this.profile.format_pref.age_birthday.chosen
      let expectedSalary = this.formData.expected_salary
      if (expectedSalary) {
        if (expectedSalary === '100k以上') {
          this.expect_min_salary = 100
          this.expect_max_salary = ''
        } else {
          let arr = expectedSalary.split('-')
          this.expect_min_salary = Number(arr[0].substring(0, arr[0].length-1))
          this.expect_max_salary = Number(arr[1].substring(0, arr[1].length-1))
        }
      } else {
        this.expect_min_salary = ''
        this.expect_max_salary = ''
      }
		},
		mounted () {
			this.initProfileData()
      if(this.isFirstCvInfo.isFirst){
        this.formData.phone = this.formData.phone || this.isFirstCvInfo.data.phone || ''
      }
		},
		watch: {
			checkCloseEditModule: function (state) {
				if (state) {
					this.profileBack()
					//设置是否需要取消当前编辑状态，并返回
					setTimeout(() => {
						this.setCheckCloseEditModule(false)
					}, 10)
				}
			},
			// 监听是否退出模块编辑
      quitResumeEditor(value){
			  if(value) {
          // 还原状态
			    this.setQuitResumeEditor(false);
          // 执行退出模块编辑
          this.back();
        }
      },
		},
		components: {
			richText,
			cvRadio,
			suggestCard,
      cvAuxiliary,
      autoplayCity,
      autoplayPosition
		},
		filters: {
			age (d) {
				if (!d) {
					return ''
				}
				let time = Date.now() - new Date(d).getTime()
				return Math.ceil(time / 1000 / 60 / 60 / 24 / 365) + '岁'
			}
		},
		methods: {
			// 映射
			...mapActions('cvsEditor', [ 'createdCv', 'createdProfile', 'editProfile' ]),
			...mapActions('editor', [ 'createCvDetail', 'updateProfileData', 'createProfileData' ]),
			...mapActions('app', [ 'setAlertData' ]),
			...mapMutations('editor', [ 'setCurrentInfo', 'setProfileData', 'setSuggestInfo', 'setCheckCloseEditModule', 'setOpenSidebarModule', 'setQuitResumeEditor' ]),
      
      minChange(min) {
        if (!min) {
          this.expect_max_salary = ''
          return
        }
        if (min < 100) {
          this.expect_max_salary = min + 1
        } else {
          this.expect_max_salary = ''
        }
      },
      maxChange (max) {
        if (!max) {
          this.expect_min_salary = ''
          return
        }
      },
      selectSalaryFun () {

        let str = null
        let minSalary = this.expect_min_salary
        let maxSalary = this.expect_max_salary

        if (!minSalary && !maxSalary) {
          this.formData.expected_salary = ''
          return
        }

        if (minSalary === 100) {
          str = '100k以上'
        } else {
          str = `${minSalary}k-${maxSalary}k`
        }
        this.formData.expected_salary = str
      },
      // 自动补全 城市 选择
      selectCityValue (data) {
        this.formData.exp_city = data.name || data.value
        this.formData.city_id = data.id || null
      },
      // 自动补全 职位 选择
      selectPisitionValue (data) {
        this.formData.exp_job = data.name || data.value || data.level3 || null
        this.formData.profession_id = data.profession_id || null
      },
      // 期望薪资 选择
      selectSalaryValue (data) {
         //console.log(data)
				 if (!data) { // 清空
					 return
				 }
        if (data === 100) {
          this.formData.expected_salary = '100k以上'
        } else {
          this.formData.expected_salary = `${data}k-${data+1}k`
        }
      },
      // 切换求职状态
      toggleCurrentJob (val) {
        clearTimeout(this.currentJobBoxTimer)
        this.$refs['currentJobRef'].focus()
        this.formData.current_job = val
      },
      // 隐藏 当前状态选择项
      hiddenCurrentJobBox () {
        this.currentJobBoxTimer = setTimeout(() => {
          this.showCurrentJobBox(false)
        }, 200)
      },
      // 显示 当前状态选择项 
      showCurrentJobBox (flag) {
        this.currentJobBoxVisible = flag
      },
			closeCard () {
				this.setSuggestInfo({})
			},
			// input 框入值的变化
			change () {
			},
			// 初始化基本信息数据
			initProfileData () {
				let fields = [ 'homepage', 'wechat', 'linked_in', 'height', 'weight', 'ethnic', 'hometown', 'political_status', 'marriage', 'gender', 'birthday', 'exp_job', 'current_job', 'expected_salary' ]
				fields.forEach(item => {
					const index = this.infoModule.findIndex(i => i.key === item)
					if (this.profile[item] && index === -1) {
						this.infoModule.push({
							key: item,
							title: placeholder[item],
							placeholder: this.getMenuKeyValue(item).placeholder
						})
					}
				})
				// eslint-disable-next-line no-unused-vars
				this.infoMenu.forEach(item => {
					item = item.filter(value => this.formData[value.key])
				})
				//初始化模块
				this.initInfoModule()
			},
      async changeRuleType () {
				this.saveRules = true
      },
			// 保存
			async save () {
				// 显示验证信息
				this.isShowRulesMsg = true
        await this.changeRuleType()
				this.noStyle = false
				setEditNumLocalStorage()
				this.$refs['editModuleBasicInfo'].validate(async (valid) => {
					if (!valid) return false
					try {
						let { basic_info: { token, kind } } = this.cvDetail
						let res = {}
						let createCvDetailCode = 1000
						// 未创建简历
						if (kind === 'sample' || kind === 'template') {
							let createRes = await this.createCvDetail({
								payload: JSON.parse(JSON.stringify(this.cvDetail)),
								dontReload: true
							})
							createCvDetailCode = createRes.code
							if (createRes.code !== 1000) {
								this.$message.error(createRes.message)
								return
							}
						}
            // console.log('保存111===========>', this.formData)
            // this.formData.exp_city = this.intentionData.exp_city
            // console.log('保存222===========>', this.formData, this.intentionData.exp_city)
						this.formData.format_pref.age_birthday.chosen = this.chosen || null
						this.formData.format_pref.age_birthday.date_format = this.formData.format_pref.age_birthday.chosen === 'birthday' ? 'yyyy_d' : ''
            this.formData.format_pref.show_attr_name = this.formData.show_attr_name
						delete this.formData.show_attr_name
						if (!this.profile.id) {
							// 没有创建profile
							res = await this.createProfileData({ token, payload: this.formData })
						} else {
							// 更新profile
							res = await this.updateProfileData({ token, payload: this.formData })
						}
						if (res.code !== 1000) {
							// this.$message.error(res.message)
							return false
						}
						//检测是否需要刷新
						if (createCvDetailCode && (kind === 'sample' || kind === 'template')) {
							setTimeout(() => {
								window.location.reload()
							}, 200)
						} else {
							// this.$message.success('基本信息保存成功')
							this.resetEditState()
							this.setDealCheck(true)
							if (this.saveFormDataByDialog) {
								this.saveFormDataByDialog()
								this.setFormDataFn(null)
								// commit('setFormDataFn', null)
							}
						}
					} catch (error) {
						console.log(error)
					}
					// 提交保存模块监听
					this.$eventBus.$emit("saveEditorModule", 'basicInfo')
				})
			},
			// 获取key value
			getMenuKeyValue (key) {
				let menu = JSON.parse(JSON.stringify(infoMenu))
				menu = menu[0].concat(menu[1])
				for (let i = 0; i < menu.length; i++) {
					if (menu[i].key === key) {
						return menu[i]
					}
				}
				return {}
			},
			// 获取是否在infoModule
			isOnInfoModule (key) {
				for (let i = 0; i < this.infoModule.length; i++) {
					if (this.infoModule[i].key === key) return true
				}
				return false
			},
			// 添加信息模块
			addModule (data, index, num) {
				let infoModule = this.infoModule
				let module = {
					...data,
					value: ''
				}
				// //如果添加的是（年龄/生日），没增加默认值
				if (data.key === 'birthday') {
					this.chosen = 'age'
				}
				infoModule.push(module)
				this.infoModule = infoModule
				// 删除添加模块
				let infoMenu = this.infoMenu
				infoMenu[num].splice(index, 1)
				this.infoMenu = infoMenu
			},
			getRulesTitle (title, check) {
				for (let i = 0; i < rules.rules.length; i++) {
					if (rules.rules[i].name === title || (check && check.name === rules.rules[i].name)) {
						return rules.rules[i].title
					}
				}
				return '提示'
			},
			showAlert () {
				const alertData = {
					show: true,
					type: 'message',
					messageTitle: '温馨提示',
					showCancelButton: true, //取消按钮
					showConfirmButton: true, // 确定按钮
					confirmButtonText: '保存',
					cancelButtonText: '不保存',
					confirmButtonClass: 'cvs-edit-cancelButtonClass',
					cancelButtonClass: 'cvs-edit-confirmButtonClass',
					messageContent: `<p>还有内容尚未保存，是否保存再离开？</p>`,
					cancel: async close => {
						let { data } = this.backUpInfo
						this.setProfileData(data)
						this.resetEditState()
						close()
						//打开右边tab
						this.setOpenSidebarModule({
							...this.openSidebarModule,
							state: true,
						})
					},
					confirm: async close => {
						this.debounceSave()
						close()
					}
				}
				this.setAlertData(alertData)
			},
			close () {
				this.$emit('close')
			},
			initInfoModule () {
				let infoMenu = [ [], [] ]
				this.infoMenu.forEach((bItem, Bindex) => {
					bItem.forEach((item, index) => {
						if (!this.formData[item.key]) {
							infoMenu[Bindex].push(item)
						}
					})
				})
				this.infoMenu = infoMenu

			},
			// 年龄或生日 change
			chosenChange (value) {
				console.log(value)
				this.formData.format_pref.age_birthday.chosen = value
			}
		},
	}
</script>
<style lang="scss" scoped>
  .edit-editor {
    overflow: hidden;
    padding: 0 28px;
    margin-top: 20px;
    .name {
      font-size: 16px;
      color: #404040;
    }
    .font-size-14 {
      font-size: 14px;
    }


    .add-module {
      display: flex;
      flex-wrap: wrap;
      .add-module-menu {
        height: 38px;
        line-height: 38px;
        padding: 0 24px;
        color: #606060;
        font-size: 14px;
        background: #F9F9F9;
        margin-right: 16px;
        margin-bottom: 16px;
        cursor: pointer;
        b {
          margin-right: 4px;
          font-size: 16px;
        }
      }
    }

  }
  .check-unnecessary {
    ::v-deep .el-input__inner {
      border-color: #DCDFE6 !important;
    }
    ::v-deep .el-form-item__error {
      color: #9c9c9c !important;
    }
  }
  ::v-deep .no-style .el-input__inner {
    border-color: #ECECEC !important;
    &:hover {
      border-color: #CFCFCF !important;
    }
  }

  .module-title {
    font-size: 16px;
    font-weight: 500;
    color: #404040;
    line-height: 22px;
    margin-top: 30px;
  }

  .current-job-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 12px;

    .current-job-item {
      cursor: pointer;
      padding: 4px 12px;
      border-radius: 14px;
      border: 1px solid #ECECEC;
      margin-right: 10px;
      margin-bottom: 8px;
      font-size: 14px;
      color: #9C9C9C;
      line-height: 20px;

      &:hover,
      &.active {
        color: #FF6644;
        border-color: #FF6644;
      }

    }
  }

  .edit-editor-salary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;

    ::v-deep {
      .el-select {
        height: 40px !important;
      }
    }

    .salary-item {
      position: relative;
      width: 100%;
    }
    
    .salary-item-text {
      color: #404040;
      margin: 0 8px;
    }
  }

</style>
